import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const demographicsSlice = createSlice({
  name: "entities/patient-stats/demographics-slice",
  initialState,
  reducers: {
    setDemographics: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setDemographics } = demographicsSlice.actions;

export default demographicsSlice.reducer;
